@if (company(); as company) {
  <span
    [class]="disableClipboardCopy() ? '' : 'org-nr'"
    [title]="disableClipboardCopy() ? '' : ('company.copy_company_org_nr.tooltip' | translate)"
    (click)="copyToClipboard($event, company.org_nr)">
    @if (showFlag()) {
      <span [hidden]="!company.org_nr_schema" class="flag flag-{{ company.org_nr_schema | lowercase }} me-1"></span>
    }
    {{ company.org_nr | orgnr: (showSchema() ? company.org_nr_schema : '') }}
  </span>
}
